import { render, staticRenderFns } from "./workorder-charts-type.vue?vue&type=template&id=565b88ba&scoped=true&"
import script from "./workorder-charts-type.vue?vue&type=script&lang=js&"
export * from "./workorder-charts-type.vue?vue&type=script&lang=js&"
import style0 from "./workorder-charts-type.vue?vue&type=style&index=0&id=565b88ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b88ba",
  null
  
)

export default component.exports